<template>
	<div class="Tabs">
		<ul class="tabs qjc-clearfix">
			<li @click="$emit('checkTab', 'Personal')" :class="{ active: tab == 'Personal' }" class="qjc-fl">个人信息</li>
			<li @click="$emit('checkTab', 'Questions')" :class="{ active: tab == 'Questions' }" class="qjc-fl">问卷信息</li>
			<li @click="$emit('checkTab', 'Bodily')" :class="{ active: tab == 'Bodily' }" class="qjc-fl">体型信息</li>
			<li @click="$emit('checkTab', 'Biochemical')" :class="{ active: tab == 'Biochemical' }" class="qjc-fl">生化指标</li>
		</ul>
	</div>
</template>

<script>
	export default{
		name: 'tabs',
		data() {
			return {
				
			}
		},
		props: ['tab']
	}
</script>

<style lang="scss" scoped>
	.Tabs{
		.tabs{
			font-size: 0.15rem;
			color: #777F8F;
			line-height: 0.16rem;
			margin-top: 0.32rem;
			padding-bottom: 0.16rem;
			border-bottom: 0.01rem solid #F0F4F5;
			
			li{
				position: relative;
				margin-right: 0.56rem;
				cursor: pointer;
				transition: all .3s;
				
				&::after{
					position: absolute;
					left: 50%;
					bottom: -0.16rem;
					content: '';
					width: 0;
					height: 0;
					border-radius: 0.02rem;
					background-color: transparent;
					transform: translateX(-50%);
					transition: all .3s;
				}
				&.active{
					color: #6681FA;
					font-weight: 600;
				}
				&.active::after{
					width: 0.16rem;
					height: 0.04rem;
					background-color: #6681FA;
				}
			}
		}
	}
</style>
